/**
 * The search shortcut as this device writes it: "⌘K" on Apple devices,
 * "Ctrl K" elsewhere. One helper so the sidebar and the 404 page agree
 * (UX-208: the 404 said ⌘K on Windows while the sidebar said Ctrl K).
 */
export function isApplePlatform(nav: Pick<Navigator, 'platform' | 'userAgent'> | undefined =
  typeof navigator === 'undefined' ? undefined : navigator): boolean {
  if (!nav) return false
  return /Mac|iPhone|iPad|iPod/i.test(nav.platform || '') || /Mac OS X|iPhone|iPad/i.test(nav.userAgent || '')
}

export const SHORTCUT_LABEL = isApplePlatform() ? '⌘K' : 'Ctrl K'
